import { get, put, destroy, upload, uploadPut } from 'utils/fetchRequest';

// ── Public ────────────────────────────────────────────────────
export const getClubsList = async () => {
    try {
        return await get('clubs');
    } catch (err) {
        return { error: err };
    }
};

export const getClubDetail = async (id) => {
    try {
        return await get(`clubs/${id}`);
    } catch (err) {
        return { error: err };
    }
};

// ── Admin ─────────────────────────────────────────────────────
export const getClubsAdmin = async (search, page, limit) => {
    try {
        return await get(
            `clubs/admin?1=1${search ? `&search=${search}` : ''}${page ? `&page=${page}` : ''}${limit ? `&limit=${limit}` : ''}`
        );
    } catch (err) {
        return { error: err };
    }
};

export const getClubAdminDetail = async (id) => {
    try {
        return await get(`clubs/admin/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createClub = async (formData) => {
    try {
        return await upload('clubs', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateClub = async (id, formData) => {
    try {
        return await uploadPut(`clubs/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const deleteClub = async (id) => {
    try {
        return await destroy(`clubs/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const reorderClubs = async (items) => {
    try {
        return await put('clubs/reorder', items);
    } catch (err) {
        return { error: err };
    }
};
